/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NgxScrollTopCoreService as ɵa} from './lib/ngx-scrolltop.core.service';